import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { BsChevronDown } from "react-icons/bs";

function shuffle(array) {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex > 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
}

function getRandomIntInclusive(min, max) {
  const minCeiled = Math.ceil(min);
  const maxFloored = Math.floor(max);
  return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled);
  // The maximum is inclusive and the minimum is inclusive
}

function hasDescription(member) {
  return member.description && member.description.trim().length > 0;
}

function hasPicture(member) {
  const placeholderRegex = /headshot-placeholder/i;
  return member.picture && !placeholderRegex.test(member.picture);
}

export function TeamMembers({ allTeamMembers }) {
  const { innerWidth } = window;
  const [show, setShow] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [all_members, setAllMembers] = useState([]);

  const handleClose = () => {
    setTimeout(() => setSelectedMember(null), 250);
    setShow(false);
  };
  const handleShow = (member) => {
    if (hasDescription(member)) {
      setSelectedMember(member);
      setShow(true);
    }
  };

  const membersByTeam = all_members.reduce((acc, cur) => {
    const team = cur.team || "Other";
    team.forEach(t => {
      if (!acc[t]) acc[t] = [];
      acc[t].push(cur);
    })
    return acc;
  }, {});

  // Set placeholder image for members without an image, based on team
  Object.entries(membersByTeam).forEach(([team, members]) => {
    members.forEach(member => {
      if (!hasPicture(member)) {
        if (team === "Soccer") {
          const pictureIndex = getRandomIntInclusive(0, 1); // 2 placeholder images for soccer
          if (pictureIndex === 0) {
            member.picture = "/images/headshots/headshot-placeholder-robot.jpg";
          }
          else if (pictureIndex === 1) {
            member.picture = "/images/headshots/headshot-placeholder-robot-2.jpg"
          }
        }
        if (team === "Flyers") {
          member.picture = "/images/headshots/headshot-placeholder-drone.jpg";
        }
        if (team === "Other") {
          member.picture = "/images/headshots/headshot-placeholder.jpg";
        }
      }
    });
  });

  useEffect(() => {
    var teamLeaders = allTeamMembers.filter(member => member.role === "Team Leader");
    var studentCoLeads = allTeamMembers.filter(member => member.role === "Student Co-Lead");
    var teamMembers = allTeamMembers.filter(
      member => member.role !== "Team Leader" && member.role !== "Student Co-Lead"
    );

    var pictureAndDescriptionStudents = []; // Students with pictures and descriptions
    var pictureStudents = []; // Students with pictures but no descriptions
    var descriptionStudents = []; // Students with descriptions but no pictures
    var otherStudents = []; // Students with neither pictures nor descriptions

    teamMembers.forEach((student) => {
      if (hasPicture(student) && hasDescription(student)) {
        pictureAndDescriptionStudents.push(student);
      } else if (hasPicture(student) && !hasDescription(student)) {
        pictureStudents.push(student);
      } else if (!hasPicture(student) && hasDescription(student)) {
        descriptionStudents.push(student);
      } else {
        otherStudents.push(student);
      }
    });

    shuffle(studentCoLeads);
    shuffle(pictureAndDescriptionStudents);
    shuffle(pictureStudents);
    shuffle(descriptionStudents);
    shuffle(otherStudents);
    // console.log("pictureAndDescriptionStudents:", pictureAndDescriptionStudents.map(student => student.name));
    // console.log("pictureStudents:", pictureStudents.map(student => student.name));
    // console.log("descriptionStudents:", descriptionStudents.map(student => student.name));
    // console.log("otherStudents:", otherStudents.map(student => student.name));

    setAllMembers([...teamLeaders, ...studentCoLeads, ...pictureAndDescriptionStudents, ...pictureStudents, ...descriptionStudents, ...otherStudents]);
  }, [allTeamMembers, innerWidth]);

  return (
    <>
      {Object.entries(membersByTeam).map(([team, members]) => (
        <Container key={team} className="mb-4">
          <h4 className="mb-2"><b>{team}</b></h4>
          <Row xs={2} md={3} lg={4} xl={5} className="g-4">
            {members.map((teamMember, index) => {
              const hasDescription = teamMember.description && teamMember.description.trim().length > 0;
              return (
                <Col key={index}>
                  <Card className="member-card" onClick={() => handleShow(teamMember)}>
                    {hasDescription && <div className="show-more-overlay">Show More</div>}
                    <Card.Img variant="top" src={teamMember.picture} />
                    <Card.Body style={{ padding: "10px" }}>
                      <Card.Title style={{ fontFamily: "museo", fontWeight: 900, textTransform: "uppercase", fontSize: "1.05rem", margin: "10px 0 0 0", color: "white" }}>
                        {teamMember.name}
                      </Card.Title>
                      {hasDescription && <BsChevronDown className="show-more-icon" />}
                      {!hasDescription && <BsChevronDown className="show-more-icon" style={{ color: "rgba(56, 56, 56, 1)" }} />}
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Container>
      ))}

      {selectedMember && (
        <Modal show={show} onHide={handleClose} size="lg" centered style={{ transition: "all 0.25s"}}>
          <Modal.Header closeButton style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.1)", background: "#111", color: "white" }}>
            <Modal.Title style={{ fontFamily: "museo", fontWeight: 900, color: "#E61E2A", textTransform: "uppercase" }}>
              {selectedMember.name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="m-3" style={{ background: "#111", color: "white" }}>
          {innerWidth < 992 ? (
            // Small screens: image on top, description below
            <>
              <div className="text-center mb-3">
                <img src={selectedMember.picture} alt={selectedMember.name} style={{ width: "70%", borderRadius: "8px" }} />
              </div>
              <div>
                <p>{selectedMember.description}</p>
              </div>
            </>
          ) : (
            // Medium and up: image left, description right
            <Row className="g-4 align-items-center">
              <Col md={4} lg={4} className="text-center">
                <img src={selectedMember.picture} alt={selectedMember.name} style={{ width: "100%", borderRadius: "8px" }} />
              </Col>
              <Col md={8} lg={8}>
                <p>{selectedMember.description}</p>
              </Col>
            </Row>
          )}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}
